import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../../shared';
import { CampanhaLeadViewModule } from '../../leads/view';
import { CampanhaClienteViewModule } from '../../clientes/view';
import { CampanhaPedidoViewModule } from '../../pedidos/view';
import { CampanhaResultadoViewComponent } from './campanha-resultado-view.component';

@NgModule({
    imports: [
        SharedModule,
        CampanhaLeadViewModule,
        CampanhaClienteViewModule,
        CampanhaPedidoViewModule
    ],
    declarations: [
        CampanhaResultadoViewComponent
    ],
    exports: [
        CampanhaResultadoViewComponent
    ]
})
export class CampanhaResultadoViewModule { }
